import { render, staticRenderFns } from "./ContainerArea.vue?vue&type=template&id=243605b0"
import script from "./ContainerArea.vue?vue&type=script&lang=js"
export * from "./ContainerArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports